module.exports = __webpack_public_path__ + "static/logo-9b14d3ce98c17fa5196266e331bf0faa.svg";